import app from './modules/app'
import errorLog from './modules/errorLog'
import permission from './modules/permission'
import tagsView from './modules/tagsView'
import user from './modules/user'
import errorMsg from './modules/errorMsg'
import getters from './getters'
import channelManage from './modules/channel-manage'
import channel from './modules/channel'

const store = new Vuex.Store({
  modules: {
    app,
    errorLog,
    permission,
    tagsView,
    user,
    errorMsg,
    channelManage,
    channel
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js